import styled from '@emotion/styled';

import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';

import FONT from '@zola/zola-ui/src/styles/emotion/fonts';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';
import COLORS, { COLORS_TEXT } from '@zola/zola-ui/src/styles/emotion/colors';
import MEDIA_QUERY from '@zola/zola-ui/src/styles/emotion/mediaQuery';

export const Container = styled.div`
  padding-top: ${SPACING.MD};
`;

export const Title = styled.h4`
  font-size: ${FONT.FONT_SIZE_SMALL};
  font-weight: ${FONT.FONT_WEIGHT_BOLD};
  line-height: ${FONT.FONT_SIZE_SMALL};
  margin: 0 0 ${SPACING.XS};
`;

export const NoEntityContainer = styled.div`
  align-items: center;
  background: ${COLORS.WHITE};
  border-radius: 4px;
  border: 2px dashed ${COLORS.SCREAMING_GREY};
  display: flex;
  padding: 30px 15px;
  width: 100%;
  ${MEDIA_QUERY.TABLET} {
    flex-direction: column;
    padding: 30px;
    text-align: center;
  }
`;

export const Label = styled.div`
  ${FONT.textSizeCompact(FONT.FONT_SIZE_SMALL)};
  color: ${COLORS_TEXT.BODY};
  padding: 0 ${SPACING.SM};
  ${MEDIA_QUERY.TABLET} {
    margin-bottom: ${SPACING.MD};
    max-width: 231px;
    padding: 0;
  }
`;

export const Icon = styled.img`
  flex: 0 0 auto;
  width: 64px;
  ${MEDIA_QUERY.TABLET} {
    margin-bottom: ${SPACING.XS};
    width: 120px;
  }
`;

export const StyledButton = styled(ButtonV3)`
  flex: 0 0 auto;
  ${MEDIA_QUERY.TABLET} {
    width: 208px;
  }
`;
